import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Content } from './Content';
import { useOWASContext } from '../../context';
import { Title } from '@/components/Typography';
import { Button } from '@/components/ui/Button';

export function Result(): JSX.Element {
	const { data, handlePreviousStep, handleClose } = useOWASContext();

	function handleOnPrevious(): void {
		handlePreviousStep();
	}

	return (
		<Col span={24}>
			<Row gutter={[0, 24]}>
				<Col span={24}>
					<Title level={3}>Results</Title>
				</Col>
				<Col span={24}>
					<Content />
				</Col>
				<Col span={24}>
					<Row justify="center" gutter={[24, 0]}>
						<Col>
							<Button type="ghost" onClick={handleOnPrevious} disabled={data?.is_consolidated}>
								{I18n.get('Back')}
							</Button>
						</Col>
						<Col>
							<Button type="primary" onClick={handleClose}>
								{I18n.get('Close')}
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
}
